import { render, staticRenderFns } from "./orderbuyDetail.vue?vue&type=template&id=6292f08a&scoped=true"
import script from "./orderbuyDetail.vue?vue&type=script&lang=js"
export * from "./orderbuyDetail.vue?vue&type=script&lang=js"
import style0 from "./orderbuyDetail.vue?vue&type=style&index=0&id=6292f08a&prod&lang=less&scoped=true"
import style1 from "./orderbuyDetail.vue?vue&type=style&index=1&id=6292f08a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6292f08a",
  null
  
)

export default component.exports